import { Controller } from "stimulus"
import axios from 'axios';
export default class extends Controller {

 static get targets() {
   return [];
  }

  initialize(){
  }

  connect() {
    this.load();
  }

  load() {

    const element = this.element;
    const options = {
      method: 'GET',
      headers: { 'Accept': 'text/html' },
      url: this.data.get("url")
    };
    axios(options)
        .then(function(response){
          element.innerHTML = response.data;
        }).catch(function(err){
           // t.errorsTarget.innerHTML = err.response.data.errors;
           // t.errorsTarget.style.display = "block";
        });
  }

}



// WEBPACK FOOTER //
// ./app/javascript/store_front/controllers/quote_shipping_controller.js